
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Thermorgulationsystem() {



  const cardData =
  {
    keyword: 'Thermoregulation Systems in Indore',
    heading: 'Pharmacle Health Care Private Limited: Thermoregulation Systems in Indore',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Thermoregulation Systems in Indore, ensuring precise temperature management for patients during surgeries and critical care. Our Wallabies Warm Care systems are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our thermoregulation systems are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Indore to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


    "topPlaces": [
  {
    "title": "Advanced Thermoregulation Systems in Indore",
    "description": "Pharmacle Health Care provides state-of-the-art Thermoregulation Systems in Indore, ensuring precise patient body temperature control in hospitals, ICUs, and surgical units. Our systems are designed to prevent hypothermia and support faster recovery."
  },
  {
    "title": "Forced Air Thermoregulation System for Hospitals",
    "description": "Our Forced Air Thermoregulation System delivers uniform heat distribution, helping patients in Indore’s surgical and critical care settings maintain normothermia and avoid temperature-related complications."
  },
  {
    "title": "Portable Thermoregulation Device for Emergency Care",
    "description": "Lightweight and efficient, our Portable Thermoregulation Device is ideal for ambulances, emergency rooms, and mobile healthcare units in Indore. It provides rapid and reliable warming during patient transport."
  },
  {
    "title": "Neonatal Thermoregulation System for NICUs",
    "description": "Specially designed for newborns, our Neonatal Thermoregulation System ensures gentle and precise temperature regulation in Indore’s NICUs and maternity wards, reducing the risk of neonatal hypothermia."
  },
  {
    "title": "ICU Patient Thermoregulation System",
    "description": "Pharmacle Health Care offers ICU-specific Thermoregulation Systems in Indore, supporting critically ill patients with continuous warming solutions that stabilize core body temperature during treatment."
  },
  {
    "title": "Surgical Thermoregulation Equipment for Operation Theaters",
    "description": "Essential for operation theaters, our Surgical Thermoregulation Equipment maintains patient body temperature throughout procedures, improving safety and reducing perioperative risks in Indore hospitals."
  },
  {
    "title": "Preoperative & Postoperative Warming Systems",
    "description": "Our systems provide effective warming before and after surgery, enhancing patient comfort and minimizing complications. Pharmacle Health Care supports surgical teams across Indore with trusted solutions."
  },
  {
    "title": "Veterinary Thermoregulation System for Clinics",
    "description": "Pharmacle Health Care extends its expertise to veterinary care in Indore with reliable Thermoregulation Systems that ensure safe body temperature management for pets and livestock during medical procedures."
  },
  {
    "title": "Emergency Patient Warming Systems for Trauma Units",
    "description": "Our Emergency Patient Warming Systems are a must-have for Indore’s trauma and emergency centers. They deliver quick stabilization of body temperature for critically ill or injured patients."
  },
  {
    "title": "Disposable Warming Blankets for Safe Clinical Use",
    "description": "Pair Pharmacle Health Care’s Thermoregulation Systems with Disposable Warming Blankets for hygienic, single-use warming solutions. Trusted by hospitals and clinics in Indore for infection control and patient safety."
  }
],

"services": [
    {
        "name": "Thermoregulation Systems Indore",
        "description": "Pharmacle Health Care Private Limited offers advanced thermoregulation systems in Indore, designed to regulate patient body temperature during medical procedures. These systems are ideal for preventing hypothermia and ensuring patient safety and comfort throughout surgery and recovery."
    },
    {
        "name": "Indore Patient Warming Devices",
        "description": "We provide patient warming devices in Indore to help maintain a stable body temperature during medical treatments. These devices are crucial in preventing hypothermia and ensuring optimal conditions for patients undergoing surgery, recovery, or critical care."
    },
    {
        "name": "Forced Air Warming System Indore",
        "description": "Our forced air warming systems in Indore ensure patient comfort by maintaining their body temperature during surgery, recovery, and critical care. These systems use warm air circulation to prevent hypothermia and enhance overall patient safety."
    },
    {
        "name": "Patient Warming System Supplier Indore",
        "description": "Pharmacle Health Care is a trusted supplier of patient warming systems in Indore, offering effective solutions for maintaining stable body temperatures during medical treatments. These systems are designed to provide safe, reliable, and comfortable conditions for patients throughout their care."
    },
    {
        "name": "Indore Medical Temperature Management Devices",
        "description": "We offer medical temperature management devices in Indore, which are essential for regulating patient body temperature during medical procedures. These devices help prevent temperature-related complications and ensure that patients are kept at a safe and comfortable temperature."
    },
    {
        "name": "Indore Surgical Warming Systems",
        "description": "Our surgical warming systems in Indore are designed to maintain patient body temperature during surgeries. These systems are crucial for preventing hypothermia and ensuring a safe and comfortable surgical environment for patients."
    }
],
"tableData": [
    ["- Thermoregulation Systems Indore", "- Indore Patient Warming Devices"],
    ["- Forced Air Warming System Indore", "- Patient Warming System Supplier Indore"],
    ["- Indore Medical Temperature Management Devices", "- Indore Surgical Warming Systems"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced thermoregulation systems in Indore, designed to provide precise temperature control during medical procedures. Our technology ensures reliable performance to prevent hypothermia and other temperature-related complications, enhancing patient safety in hospitals and clinics across Indore."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a comprehensive range of thermoregulation systems in Indore, including forced air warming devices, blankets, and temperature control systems. Our solutions are designed for both surgical procedures and critical care, ensuring that your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our thermoregulation systems are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our equipment provides optimal reliability for continuous use in medical settings across Indore."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our thermoregulation systems deliver controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Indore are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our thermoregulation systems in Indore are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s thermoregulation systems are designed for seamless integration with existing medical systems in Indore. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Indore to help healthcare facilities select the right thermoregulation systems for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our thermoregulation systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Indore receives the highest standard of care."
    }
]












  }


  const faqData = [
    { question: "What is a Thermoregulation System?", answer: "A Thermoregulation System is a medical device designed to maintain a patient's body temperature within a normal range during surgeries or medical procedures, preventing hypothermia or hyperthermia. It is commonly used in intensive care and operating rooms." },
    { question: "How does a Thermoregulation System work?", answer: "The system works by using various methods such as forced air, conductive, or radiant heat to regulate and stabilize the patient’s body temperature. This ensures that the patient stays at a safe temperature throughout medical procedures." },
    { question: "Is the Thermoregulation System available in Indore?", answer: "Yes, Pharmacle Health Care Private Limited offers Thermoregulation Systems in Indore, providing hospitals and healthcare facilities with effective solutions to manage patient temperature during medical procedures." },
    { question: "What are the benefits of using a Thermoregulation System?", answer: "The benefits include preventing hypothermia or hyperthermia, reducing surgical complications, improving patient comfort, enhancing recovery times, and ensuring consistent and controlled body temperature during medical procedures." },
    { question: "How long can the Thermoregulation System maintain a patient’s temperature?", answer: "The system can maintain the patient's body temperature for the entire duration of the medical procedure, providing consistent regulation and preventing temperature fluctuations." },
    { question: "Is the Thermoregulation System easy to use?", answer: "Yes, Thermoregulation Systems are designed to be user-friendly, with simple controls that allow healthcare professionals to adjust temperature settings easily during medical treatments or surgeries." },
    { question: "Can the Thermoregulation System be used for all types of surgeries?", answer: "Yes, the Thermoregulation System is versatile and can be used for a wide range of surgeries, especially those where maintaining the patient’s body temperature is critical for patient safety." },
    { question: "Is the Thermoregulation System safe for all patients?", answer: "Yes, the system is safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and prevent any risk of overheating or underheating." },
    { question: "How can I purchase a Thermoregulation System in Indore?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Thermoregulation System to your healthcare facility in Indore." },
    { question: "Does Pharmacle Health Care provide support for Thermoregulation Systems?", answer: "Yes, we offer complete support for Thermoregulation Systems, including installation, staff training, and ongoing maintenance services to ensure reliable performance and optimal patient care." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Thermoregulation System from Pharmacle Health Care in our Indore hospital, and it has significantly improved our ability to maintain patient safety during surgeries. The system is easy to use and reliable.',
      name: 'Dr. Amit Sharma',
    },
    {
      text: 'The Thermoregulation System from Pharmacle Health Care has been a valuable addition to our clinic in Indore. It ensures that our patients stay at the correct body temperature during procedures, improving both comfort and outcomes.',
      name: 'Dr. Priya Reddy',
    }
  ];
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Thermoregulation Systems in Indore",
    "description": "Explore advanced Thermoregulation Systems in Indore for effective patient warming and temperature control during medical procedures. Our systems ensure optimal thermoregulation for surgical and hospital settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "1420"
    }
  };
  

  

  return (
    <div>
  <Helmet>
    <title>Thermoregulation Systems in Indore | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore Thermoregulation Systems in Indore for effective patient warming and temperature management during medical procedures. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Thermoregulation Systems Indore, Indore Patient Warming Devices, Forced Air Warming System Indore, Patient Warming System Supplier Indore, Indore Medical Temperature Management Devices, Indore Surgical Warming Systems"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thermorgulationsystem;